export default "__VITE_ASSET__kMTbEHeP__ 400w, __VITE_ASSET__Bx$fqClB__ 800w, __VITE_ASSET__Bni2u3zd__ 1024w";